import React from 'react';
import { noop } from 'lodash-es';

import { FjButton, fjButtonTypes } from 'components/primitives';
import type { FjButtonType } from 'components/primitives/fj-button';

interface ButtonStyle {
  color?: string | null;
  background?: string | null;
  borderColor?: string | null;
  textDecoration?: string;
}

interface BaseButtonProps {
  rel?: string;
  target?: string;
  href?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  defaultStyle?: ButtonStyle;
  hoverStyle?: ButtonStyle;
  buttonType?: FjButtonType;
  disabled?: boolean;
  children?: React.ReactNode;
}

const BaseButton = ({
  rel = '',
  target,
  href,
  onClick = noop,
  defaultStyle,
  hoverStyle,
  buttonType = fjButtonTypes.XL,
  disabled,
  children,
}: BaseButtonProps): React.JSX.Element => (
  <FjButton
    rel={rel}
    target={target}
    href={href}
    onClick={onClick}
    defaultStyle={defaultStyle}
    hoverStyle={hoverStyle}
    buttonType={buttonType}
    disabled={disabled}
  >
    {children}
  </FjButton>
);

export default BaseButton;
